import { render, staticRenderFns } from "./managePermission.vue?vue&type=template&id=084d1149&"
import script from "./managePermission.vue?vue&type=script&lang=js&"
export * from "./managePermission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports